module.exports = __webpack_public_path__ + "img/red-circle-table-3.3fd02f9d.png";